import { render } from "./explore-pois.vue?vue&type=template&id=4b555f46"
import script from "./explore-pois.vue?vue&type=script&lang=js"
export * from "./explore-pois.vue?vue&type=script&lang=js"

import "./explore-pois.vue?vue&type=style&index=0&id=4b555f46&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__